
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

// @types
import { AttachInvoicesToContainerPayload, Container } from '@/new-services/types/planning'

// @new-services
import planningAPI from '@/new-services/planning.service'

// @validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        waveId: {
            type: Number,
            default: null,
        },
        sectorIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        invoiceIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        date: {
            type: String,
            default: null,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            containerId: null as number | null,
        })

        const data_state = reactive({
            containers: {
                is_loading: false,
                is_failed: false,
                list: [] as Container[],
            },
        })

        const state_form$ = useVuelidate(
            {
                containerId: { required },
            },
            state
        )

        const loadContainers = async () => {
            try {
                data_state.containers.is_loading = true

                const response = await planningAPI.getContainers({
                    waveId: props.waveId,
                    sectorIds: props.sectorIds,
                    date: props.date,
                    statusIds: [1, 2],
                })

                data_state.containers.list = response.data.data

                data_state.containers.is_failed = false
            } catch (error) {
                data_state.containers.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении списка контейнеров произошла ошибка',
                })
            } finally {
                data_state.containers.is_loading = false
            }
        }

        onBeforeMount(loadContainers)

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const onSubmit = () => {
            if (props.loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            const payload: AttachInvoicesToContainerPayload = {
                invoiceIds: props.invoiceIds,
            }

            emit('submit', { containerId: state.containerId, payload })
        }

        return {
            state,
            data_state,
            state_form$,
            loadContainers,
            onCancel,
            onSubmit,
        }
    },
})
